export function MsgPage({msg})
{
      return<>
            <h1 className="text-center mt-5">{msg}</h1>
      </>
};
